import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import { SharedModule } from '../../shared';
import { LogoutComponent } from './logout';
import { LoginComponent } from './login';

const components = [LogoutComponent, LoginComponent];

const modules = [
  SharedModule,
  TranslateModule.forChild({
    extend: true
  })
];

@NgModule({
  declarations: [...components],
  exports: [LoginComponent],
  imports: [...modules]
})
export class AuthenticationModule {}
